import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import { type FilterItem } from 'widgets/FilterEditor/model'

export const LocalFilterTypes = new Set(['broadcast'])

export const isWidgetLocal = <T extends IFilterValue, C>(filterItem: FilterItem<T, C>) => {
  return LocalFilterTypes.has(filterItem.type)
}
